"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowedDealLabels = exports.PRODUCT_INFO_LABEL = void 0;
var _presentationComponents = require("@ori/presentation-components");
const PRODUCT_INFO_LABEL = exports.PRODUCT_INFO_LABEL = 'product-info-label';
const allowedDealLabels = exports.allowedDealLabels = [_presentationComponents.NEW_EDITION];
//# sourceMappingURL=constants.js.map